import { Helmet } from 'react-helmet';
import {
  Box,
  Card,
  CardContent,
  Alert,
  Button,
  Container,
  LinearProgress,
  TablePagination,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import ItemDetails from 'src/components/iso/ItemDetails';
import ListToolbarFilter from 'src/components/iso/ListToolbarFilter';

import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import moment from 'moment';

import { checkAutoLogin } from 'src/actions/getTokenActions';
import Moment from 'react-moment';
import Sorting from 'src/components/Sorting';
import { useCallback } from 'react';

const IsosList = () => {
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(0);
  const [data, setdata] = useState([]);
  const [count, setCount] = useState(0);
  const [sum, setSum] = useState(0);

  const isLogin = useSelector(state => state.gettocken.islogin);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const myRef = useRef(null)
  const [progress, setprogress] = useState(false);
  const [disableFilter, setDisableFilter] = useState(false);

  // //////////////////////////////////////////////
  // Table sorting
  const [sortRack, setRackSorting] = useState('none');
  const [sortDatum, setDatumSorting] = useState('AZ');
  const [sort, setSort] = useState('Date');
  const [sortMode, setSortMode] = useState('asc');
  // Filter
  const [AccountId, setAccountId] = useState('');
  const [From, setFrom] = useState(moment.utc().subtract(1, 'day').format());
  const [To, setTo] = useState(moment.utc().format());
  const [Compression, setCompression] = useState('day');
  const [Datacenter, setDatacenter] = useState('');
  const [Rack, setRack] = useState('');
  const [detailDate, serDetailDate] = useState('');
  const [Circiut, setCirciut] = useState('');
  const [httpError, setHttpError] = useState(false);
  const [Phase, setPhase] = useState('');
  const [IsAcceptInterpolate, setIsAcceptInterpolate] = useState(true);

  console.log("FROM: ", From)
  console.log("TO: ", To)
  console.log("moment.utc(): ", moment.utc().subtract(1, 'day').set({ h: 0, m: 0, s: 0 }).format())
  console.log("moment: ", moment().subtract(1, 'day').set({ h: 0, m: 0, s: 0 }).format())
  // Detail 
  const [showdetails, sethowdetails] = useState(false);
  const [deviceid, setdeviceid] = useState('');
  const [devicename, setevicename] = useState('');

  useEffect(() => {
    const apiurl = sessionStorage.getItem('apiurl')
    console.log("Apiurl", apiurl)
    let token = checkAutoLogin(dispatch)
    if (!token && isLogin === false) {
      navigate('/login', { replace: true });
    } else {

      if (showdetails) {
        return
      } else {
        console.log("TIME: ", From, To)
        setprogress(true)
        setDisableFilter(true)
        axios.get(`https://${apiurl}/api/Values/GetAllValues/?PageNumber=${page + 1}&pageSize=${limit}&AccountId=${AccountId}&From=${From}&To=${To}&Compression=${Compression}&DataCenterId=${Datacenter}&RackId=${Rack}&CircuitId=${Circiut}&PhaseId=${Phase}&IsAcceptInterpolate=${IsAcceptInterpolate}&SortMode=${sortMode}&Sort=${sort}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
          }
        }).then(res => {
          //console.log('ISOS: ', res.data)
          setdata(res.data.data)
          setSum(res.data.sum)
          setCount(res.data.totalCount);
          setprogress(false)
          setDisableFilter(false)
        }).catch(function (error) {
          setHttpError(true)
          setprogress(false)
          setDisableFilter(false)
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        }

        )
      }

    }
  }, [page, limit, From, To, Compression, Datacenter, Rack, IsAcceptInterpolate, Circiut, Phase, AccountId, isLogin, sort, sortMode])
 

  const handleRackSorting = useCallback((sortFactor) => {
    setRackSorting(sortFactor)
    setPage(0)
    setSort('Rack')
    if (sortFactor === 'AZ') {
      setDatumSorting('none')
      setSortMode('asc')
    } else if (sortFactor === 'ZA') {
      setDatumSorting('none')
      setSortMode('desc')
    } else {
      setDatumSorting('AZ')
      setSort('Date')
      setSortMode('asc')
    }
  }, []);

  const handleDatumSorting = useCallback((sortFactor) => {
    
    setDatumSorting(sortFactor)
    setPage(0)
    setSort('Date')
    if (sortFactor === 'AZ') {
      setRackSorting('none')
      setSortMode('asc')
    } else if (sortFactor === 'ZA') {
      setRackSorting('none')
      setSortMode('desc')
    } else {
      setSort('Rack')
      setRackSorting('AZ')
      setSortMode('')
    }
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
  };

  const handleSetCompression = (Compression) => {
    setCompression(Compression)
  }

  const handleSetAccountId = (AccountId) => {
    setAccountId(AccountId)
  }

  const handleSetFrom = (FromNew) => {
    setFrom(FromNew)
  }

  const handleSetTo = (ToNew) => {
    setTo(ToNew)
  }

  const handleSetDatacenter = (Datacenter) => {
    setDatacenter(Datacenter)
  }

  const handleSetRack = (rack) => {
    setRack(rack)
  }

  const handleSetCirciut = (Circiut) => {
    setCirciut(Circiut)
  }

  const handleSetPhase = (Phase) => {
    setPhase(Phase)
  }

  const handleIsAcceptInterpolate = (value) => {
    setIsAcceptInterpolate(value)
  }


  const resetquery = () => {
    setCompression('none')
    setFrom(moment.utc().subtract(1, 'month').format())
    setTo(moment.utc().format())
    setDatacenter('')
    setRack('')
    setCirciut('')
    setPhase('')
    setIsAcceptInterpolate(true)
  }

  // Handle Detail
  const showdetail = (deviceid, devicename, detailDate) => {
    sethowdetails(true)
    setDisableFilter(true)
    setdeviceid(deviceid)
    setevicename(devicename)
    serDetailDate(detailDate)

  }

  const closedetail = () => {
    setDisableFilter(false)
    sethowdetails(false)
    setdeviceid('')
    setevicename('')
  }
  return (
    <>
      <Helmet>
        <title>Auswertungen</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false} >
          <ListToolbarFilter Datacenter={Datacenter} AccountId={AccountId} disableFilter={disableFilter}
            handleSetAccountId={handleSetAccountId} handleSetCompression={handleSetCompression} handleSetFrom={handleSetFrom} handleSetTo={handleSetTo} handleSetDatacenter={handleSetDatacenter} handleSetRack={handleSetRack} handleSetCirciut={handleSetCirciut} handleSetPhase={handleSetPhase} resetquery={resetquery} handleIsAcceptInterpolate={handleIsAcceptInterpolate} sethowdetails={sethowdetails} />
          {progress &&
            <LinearProgress />
          }
          {!showdetails && !progress &&
            <Box sx={{ pt: 3 }}>
              <Card >
                <CardContent>
                  <Box sx={{ minWidth: 1020 }}>
                    <Table stickyHeader>
                      <TableHead ref={myRef} >
                        <TableRow>
                          <TableCell>
                            Datum
                          { Compression !== "none" && <span style={{ cursor: 'pointer', marginLeft: '5px' }}><Sorting sortFactor={sortDatum} callback={handleDatumSorting} /></span>}
                          </TableCell>
                          <TableCell>
                            Name
                          </TableCell>
                          <TableCell>
                            Rechenzentrum
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            Rack
                            <span style={{ cursor: 'pointer', marginLeft: '5px' }}><Sorting sortFactor={sortRack} callback={handleRackSorting} /></span>
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            Wert                          
                          </TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            Details
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          !progress && data.length === 0 &&
                          <TableRow>
                            <TableCell colSpan="6">                      
                                {!httpError &&  <Alert severity="info">Für die Ausgewählten Einstellungen sind keine Daten verfügbar </Alert>} 
                                {httpError &&  <Alert severity="error">Es ist ein Fehler aufgetreten! Bitte versuchen Sie es noch mal. </Alert>}                                                        
                            </TableCell>
                          </TableRow>
                        }
                        {data.map((item, index) => (
                          <TableRow
                            hover
                            key={index}
                          >
                            <TableCell>
                              {Compression === "none" &&
                                <span>{item.date}</span>
                              }
                              {Compression === "day" &&
                              <span>{moment(item.date, "DD.MM.YYYY").format("DD.MM.YYYY")}</span>
                              }
                              {Compression === "month" &&
                               <span>{moment(item.date, "MM.YYYY").format("MMMM YYYY")}</span>
                              }
                              {Compression === "year" &&
                                <Moment format="YYYY">{item.date}</Moment>
                              }
                            </TableCell>
                            <TableCell>
                              {item.name}
                            </TableCell>
                            <TableCell>
                              {item.dataCenter}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }}>
                              {item.rack}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }}>
                              {new Intl.NumberFormat("de-DE").format(item.value.toFixed(2))} {Compression === "none" ? "kW" : "kWh"}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }}>
                              <Button variant="outlined" onClick={() => showdetail(item.deviceId, item.name, item.date)}>Details</Button>
                            </TableCell>
                          </TableRow>
                        ))}
                        <TableRow>
                        <TableCell colSpan="6" align='right' >
                        <span style={{marginRight: '60px'}}>Summe: {new Intl.NumberFormat("de-DE").format(sum.toFixed(2))} {Compression === "none" ? "kW" : "kWh"}</span>
                        </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={count}
                      rowsPerPage={limit}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />

                  </Box>
                </CardContent>
              </Card>
            </Box>
          }
          {showdetails &&
            <ItemDetails detailDate={detailDate} deviceid={deviceid} devicename={devicename} From={From} To={To} Compression={Compression} Datacenter={Datacenter} Rack={Rack} Circiut={Circiut} Phase={Phase} IsAcceptInterpolate={IsAcceptInterpolate} closedetail={closedetail} />
          }


        </Container>
      </Box>

    </>
  );
};

export default IsosList;
